let Constants = {
    install(app) {
        let c = {
            INTERCOM_APP_ID: getIntercomAppId(),
            // TODO: we should use these (and define additional) fixed timeouts for all toast categories - as well as consider wrapping the PrimeVue toast method with own own convinience methods
            TOAST_TIMEOUT_ERROR: 5000,
            TOAST_TIMEOUT_SUCCESS: 3000
        };
        app.config.globalProperties.Constants = c;
        app.provide('Constants', c);
    }
};
export default Constants;

function getIntercomAppId() {
    if (process.env.NODE_ENV === 'production') {
        return 'mc38ealj';
    } else {
        return 'baj4yevk';
    }
}
